import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CreateAndSendPurchaseOrderDto,
  PurchaseOrder,
  PurchaseOrderContractData,
  UpsertPurchaseOrderDto,
} from '@models/resources/purchase-order.model';

/**
 * Staff-seitige Kaufauftrag-Actions (Sprint 9, ADR-011).
 *
 * Method-Mapping (BE `Admin\PurchaseOrderController`):
 * - `create(txId, dto)`     → `POST /transaction-requests/{txId}/purchase-order`
 * - `get(orderId)`          → `GET /purchase-orders/{orderId}`
 * - `update(orderId, dto)`  → `PATCH /purchase-orders/{orderId}`
 * - `send(orderId)`         → `POST /purchase-orders/{orderId}/send`
 * - `returnToCustomer(...)` → `POST /purchase-orders/{orderId}/return`
 * - `confirmIdentity(...)`  → `POST /purchase-orders/{orderId}/confirm-identity`
 *
 * Alle Responses sind das `PurchaseOrderResource`-Wire-Shape; nach jeder
 * Mutation lädt der Parent zusätzlich die TX neu, damit der TX-Status +
 * die Kaufauftrag-Card konsistent bleiben.
 */
export interface AdminPurchaseOrdersFacade {
  /**
   * „Beratung abgeschlossen" (Sprint 9 Refinement): Auftrag anlegen +
   * senden in einem Schritt (open → consulted → order_sent).
   * → `POST /transaction-requests/{txId}/purchase-order/create-and-send`
   */
  createAndSend(txId: number, dto: CreateAndSendPurchaseOrderDto): Observable<PurchaseOrder>;
  /**
   * P4: Vertragsdaten des letzten Kaufauftrags dieses Kunden als Vorlage
   * fürs Modal. `null` beim ersten Auftrag — dann wird aus den Stammdaten
   * vorbefüllt.
   * → `GET /customers/{customerId}/last-purchase-order-contract`
   */
  lastContract(customerId: number): Observable<PurchaseOrderContractData | null>;
  create(txId: number, dto: UpsertPurchaseOrderDto): Observable<PurchaseOrder>;
  get(orderId: number): Observable<PurchaseOrder>;
  update(orderId: number, dto: UpsertPurchaseOrderDto): Observable<PurchaseOrder>;
  send(orderId: number): Observable<PurchaseOrder>;
  returnToCustomer(orderId: number, comment: string): Observable<PurchaseOrder>;
  confirmIdentity(orderId: number): Observable<PurchaseOrder>;
}

export const ADMIN_PURCHASE_ORDERS_FACADE = new InjectionToken<AdminPurchaseOrdersFacade>(
  'AdminPurchaseOrdersFacade',
);
